var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.506,
    height: 19.799,
    viewBox: "0 0 20.506 19.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:none;stroke:#fff;stroke-width:3px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_6927",
    "data-name": "Group 6927",
    transform: "rotate(45 14.943 8.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_47",
    d: "M0 0L0 25",
    className: "prefix__cls-1",
    "data-name": "Line 47",
    transform: "translate(13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_48",
    d: "M25 0L0 0",
    className: "prefix__cls-1",
    "data-name": "Line 48",
    transform: "translate(0 13)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgClose);
export default __webpack_public_path__ + "static/media/hamburg-close.3e5c0ceca250141e0213165a5892863e.svg";
export { ForwardRef as ReactComponent };